import React, {Component} from 'react';
import {Row, Col, Spin} from 'antd';
import BigDataFilter from '../../components/BigDataFilter';
import asyncComponent from '../../components/asyncComponent';
import _ from 'underscore';
import {api, app} from "../../app";

const BarReact = asyncComponent(() => import('../../components/Echarts'));  //柱形图组件
const charts = [];

/**
 * 检查类型
 * @param type
 * @returns {string}
 */
function checkType(type) {
    switch (type) {
        case 1:
            return "国";
        case 2:
            return "省";
        case 3:
            return "队";
    }
}

/**
 * 生成图表一
 */
function generateChart1({signed_all, signed_in, signed_not}) {
    let options = {
        color: ['#3399CC', '#cccccc'],
        series: [
            {
                name: '签到率',
                type: 'pie',
                radius: ['40%', '70%'],
                label: {
                    normal: {
                        textStyle: {
                            fontSize: 12,
                            color: '#444'
                        }
                    }
                },
                data: [
                    {name: `${signed_in}人已签到`, value: signed_in},
                    {name: `${signed_not}人未签到`, value: signed_not},
                ],
            }
        ],
    }
    return options;
}

/**
 * 生成图表二
 */
function generateChart2(hour) {
    let options = {
        tooltip: {
            trigger: 'axis',
            formatter: '{b}时：{c}人',
        },
        xAxis: {
            type: 'category',
            data: _.range(0, 24),
            name: '小时',
            nameTextStyle: {
                color: '#999999',
            },
            axisLine: {
                show: false,
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                color: '#999999',
            },
        },
        yAxis: {
            type: 'value',
            name: '人数',
            nameTextStyle: {
                color: '#999999',
            },
            axisLine: {
                show: false,
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                color: '#999999',
            },
            minInterval: 1,
        },
        series: [
            {
                data: hour,
                type: 'line',
                lineStyle: {
                    color: '#999999',
                    width: 1,
                },
                itemStyle: {
                    color: '#666666',
                    borderColor: '#666666',
                },
            }
        ],
    }
    return options;
}

class signView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: {},
            oneOptions: {},
            twoOptions: {},
            dataInfo: {
                singin: {
                    signed_all: 0,
                    signed_in: 0,
                }
            },
            loading: true,
        };
    }

    setData(data, cb) {
        app.setState(this, data, cb);
    }

    async componentDidMount() {
        this._isMounted = true;
        window.onresize = function () {
            for (let i = 0; i < charts.length; i++) {
                charts[i].resize();
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 数据
     * @returns {Promise<void>}
     */
    dataSource = async () => {
        let {filter} = this.state, params = Object.assign({
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }, filter);
        let {flag, data, msg} = await app.post(api.SiginData, params);
        if (flag === 1) {
            let oneOptions = generateChart1(data.singin);
            let twoOptions = generateChart2(data.day);
            this.setData({
                dataInfo: data,
                oneOptions,
                twoOptions,
                loading: false,
            });
        } else {
            app.alert(msg, "warn");
        }
    }

    /**
     * 筛选变更
     * @param res
     */
    handleFilterChange = (filter) => {
        this.setData({filter, loading: true}, async () => {
            await this.dataSource();
        });
    }

    /**
     * 窗口大小变化
     * @param func
     */
    handleResize = (func) => {
        if (charts.findIndex((c) => c.id === func.id) === -1) {
            charts.push(func);
        }
    }

    render() {
        let {loading, filter, oneOptions, twoOptions, dataInfo} = this.state,
            fType = checkType(filter.type);
        let all = dataInfo.singin.signed_all || 1, sin = dataInfo.singin.signed_in;
        let lv = (sin / all * 100).toFixed(2);
        return (
            <div className="sign-view page">
                <div className="page-title">签到总览</div>
                <div className="page-content">
                    <BigDataFilter hasDate={true} change={this.handleFilterChange}/>
                    {
                        loading ? (
                            <Row type="flex" justify="center" align="middle" style={{height: 500, background: '#fff', marginTop: 20}}>
                                <Spin/>
                            </Row>
                            ) :
                            (
                                <div className="charts">
                                    <div className="chart chart1">
                                        <div className="c-title">全{fType} 存心成员签到/未签到</div>
                                        <div className="c-title">全{fType} {all}人（签到率{lv}%）</div>
                                        <BarReact option={oneOptions} height={400} resize={this.handleResize}/>
                                    </div>
                                    <div className="chart chart2">
                                        <div className="c-title">全{fType} 存心成员签到时间段</div>
                                        <BarReact option={twoOptions} height={400} resize={this.handleResize}/>
                                        <div className="c-title">签到时间段数据表记录标准：在9点-10点间签到的记录在9时。</div>
                                    </div>
                                </div>
                            )
                    }
                </div>
            </div>
        );
    }
}

export default signView;



// WEBPACK FOOTER //
// ./src/routes/bigData/SignView.jsx